<template>
	<div v-if="value" class="location-cards-wrap-box">
		<egranty-section-divider
			icon="gps_fixed"
			text="Współrzędne geograficzne (opcjonalnie)"
			:show-print-info="showPrintInfo"
		/>
		<div class="location-cards-wrap pb-2" style="display: flex">
			<div v-for="(location, index) in value" :key="index" class="location-card py-2">
				<v-card class="ma-2">
					<v-layout>
						<div class="ma-3">
							<div><strong>Współrzędna x:</strong> {{location.x}}</div>
							<div><strong>Współrzędna y:</strong> {{location.y}}</div>
							<div v-if="location.description">
								<v-layout mt-2>
									<div><strong>Opis lokalizacji (opcjonalnie):</strong>
										<div class="mt-2 ml-4 mr-5 mb-2">{{location.description}}</div>
									</div>
								</v-layout>
							</div>
						</div>
					</v-layout>
				</v-card>
			</div>
		</div>
	</div>
</template>

<script>
	import EgrantySectionDivider from "../../../../../genericComponents/EgrantySectionDivider";

	export default {
		name: "ChooseGeographicalLocationReadOnlyView",
		components: {EgrantySectionDivider},
		methods: {
			validate: () => {
				return true;
			},

			validateLocation: () => {
				return true;
			}
		},

		props: {
			value: {
				type: Array,
				defaultValue: [],
			},
			showPrintInfo: {
				type: Boolean, default: false
			}
		}
	};
</script>

<style scoped>
	.location-cards-wrap {
		display: flex;
		flex-wrap: wrap;
		width: 100%;
	}

	.location-card {
		flex: 0 50%
	}

	@media print {
		.location-cards-wrap-box {
			margin-bottom: 10px;
			border: 1px solid grey;
		}
	}
</style>